'use client';
import { useRef } from 'react';

function useDidImmutableValueChange(r) {
    return useRef(r).current !== r;
}

export { useDidImmutableValueChange };
